import styled from 'styled-components';
import { Icon } from '@web-chat-core/ui-kit';
import { VideoRenderer } from 'core';
import { videoFadeInAnimation } from 'ui/mixins';
import { BasePlaceholder, VideoLoadingOverlay } from '../view';

export { VideoLoadingOverlay };

export const SpeakerPlaceholder = styled(BasePlaceholder)`
    font-size: 32px;
    height: 40%;
    min-height: 80px;
    max-height: 150px;
    min-width: 80px;
    max-width: 150px;
`;

export const ViewerPlaceholder = styled(BasePlaceholder)`
    font-size: 14px;
    height: 40%;
    min-height: 24px;
    max-height: 150px;
    min-width: 24px;
    max-width: 150px;
`;

export const SpeakerVideoRenderer = styled(VideoRenderer)<{ $objectFit: string; $isReady?: boolean }>`
    height: 100%;
    width: 100%;
    ${({ $objectFit }) => ($objectFit ? `object-fit: ${$objectFit};` : null)}
    ${videoFadeInAnimation}
`;

export const ViewerVideoRenderer = styled(VideoRenderer)<{ $objectFit: string; $isReady?: boolean }>`
    height: 100%;
    width: 100%;
    ${({ $objectFit }) => ($objectFit ? `object-fit: ${$objectFit};` : null)}
    ${videoFadeInAnimation}
`;

export const SIPCallIcon = styled(Icon)<{ $speaker?: boolean }>`
    --icon-color: ${(props) => props.theme.root.colors.basicColors.black['50%']};

    height: ${({ $speaker }) => ($speaker ? '48px' : '20px')} !important;
    width: ${({ $speaker }) => ($speaker ? '48px' : '20px')} !important;
`;
